import classes from "./Footer.module.css";
import { memo } from "react";
import { Container, Text, Paper } from "@mantine/core";
import packageJson from "@/../package.json";

export const Footer = memo(function Footer() {
  const year = new Date().getFullYear();

  return (
    <Paper p={0} radius={0} className={classes.footer}>
      <Container fluid className={classes.inner}>
        <Text size="xs" c="dimmed">
          PhotoFuseAI © {year} v.{packageJson.version}
        </Text>
      </Container>
    </Paper>
  );
});
